import { motion } from "framer-motion";
import { assetUrl } from "@/lib/api";

export const Gallery = ({ content }) => {
  const g = content.gallery;
  if (!g || !g.images?.length) return null;

  return (
    <section
      id="galeri"
      data-testid="gallery-section"
      className="py-20 md:py-32 bg-gradient-to-b from-background to-sky-50"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center max-w-2xl mx-auto mb-14"
        >
          <span className="inline-block px-4 py-1.5 rounded-full bg-sky-100 text-sky-700 text-sm font-semibold mb-4">
            Galeri
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">{g.title}</h2>
          <p className="mt-4 text-base text-slate-500 leading-relaxed">{g.subtitle}</p>
        </motion.div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
          {g.images.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, scale: 0.92 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: (i % 4) * 0.08 }}
              data-testid={`gallery-item-${i}`}
              className={`group relative rounded-2xl overflow-hidden shadow-lg cursor-pointer ${
                i % 5 === 0 ? "lg:row-span-2 aspect-[3/4] lg:aspect-auto" : "aspect-square"
              }`}
            >
              <img
                src={assetUrl(item.image)}
                alt={item.caption || "Kegiatan"}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              {item.caption && (
                <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-2 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300">
                  <span className="text-white font-semibold text-sm">{item.caption}</span>
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
